import { ListItemIcon, ListItemText, SvgIconProps } from '@mui/material';
import { NavSubListItem } from '@procureai/ui-mui';
import queryString from 'query-string';
import { ComponentType, PropsWithChildren, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { BaseDomainType, Domain, NegotiationDomainType, QueryParam } from '~/common/types';
import { useFilters } from '~/components/Filters';
import { NavSubListItemStyled } from '~/components/NavSubListItem/NavSubListItem.styled';
import { useLocationSearchParams } from '~/hooks';
import { RouteId } from '~/routes/RouteId';

const pathNameFromDomain: { [key in Domain]?: string } = {
  [NegotiationDomainType.DEMAND]: RouteId.demand,
  [NegotiationDomainType.NEGOTIATION_CASE]: RouteId.negotiationCases,
  [BaseDomainType.SETTINGS]: RouteId.settings,
};

export interface FiltersNavListProps {
  domain?: Domain;
  Icon?: ComponentType<SvgIconProps>;
  showDot?: boolean;
}

export const FiltersNavList = ({ domain, Icon, showDot }: PropsWithChildren<FiltersNavListProps>) => {
  const [{ [QueryParam.QUERY]: queryId }] = useLocationSearchParams();

  const { filters, selected: selectedFilter } = useFilters({ domain, queryId });

  const filtersMapped = useMemo(() => {
    return filters.map((filter) => ({
      filter,
      to: {
        pathname: domain && pathNameFromDomain[domain],
        search: queryString.stringify({ [QueryParam.QUERY]: filter.queryId }),
      },
    }));
  }, [filters, domain]);

  return (
    <>
      {filtersMapped.map(({ filter, to }) => {
        const content = (
          <>
            {Icon && (
              <ListItemIcon>
                <Icon />
              </ListItemIcon>
            )}
            <ListItemText primary={filter.name} />
          </>
        );

        const Component = showDot ? NavSubListItemStyled : NavSubListItem;

        return (
          <Component key={filter.id} component={Link} selected={filter === selectedFilter} to={to}>
            {content}
          </Component>
        );
      })}
    </>
  );
};
